
// 产品tab
function applyTabLogic() {
  const tabHeaders = document.querySelectorAll('.product-tab-header > p');
  tabHeaders.forEach((tabHeader, index) => {
    tabHeader.addEventListener('click', () => {
      tabHeaders.forEach((header) => {
        header.classList.remove('active');
      });
      const tabItems = document.querySelectorAll('.product-tab-item');
      tabItems.forEach((tabItem) => {
        tabItem.classList.remove('active');
      });
      tabHeader.classList.add('active');
      const correspondingTabItem = document.querySelector(`.product-tab-item:nth-child(${index + 1})`);
      correspondingTabItem.classList.add('active');
    });
  });
}
  if (window.innerWidth > 550) {
    applyTabLogic();
  }

 // 配件轮播
function adjustSliders() {
    var sliders = document.getElementById('product-ementary-slider');
    if (!sliders) {
      return;
    }
    var flkty = new Flickity(sliders, {
      wrapAround: true,
      fullscreen: true,
      contain: true,
      freeScroll: true,
      pageDots: false,
      cellAlign: 'left'
    });

    sliders.classList.add('spring-slider-visible');
  }
 adjustSliders();




  // 配件2.0
function adjustaaaa() {
  const container = document.querySelector(".tab-container");
  if (!container) return;
  const tabButtons = container.querySelectorAll(".tab-button");
  const tabPanels = container.querySelectorAll(".tab-panel");
  const tabButtonsWrap = container.querySelector(".tab-buttons");
  const tabButtonsSlider = container.querySelector(".tab-buttons-slider");
  if (tabButtonsWrap) {
    tabButtonsWrap.addEventListener("click", (event) => {
      const btn = event.target;
      if (!btn.classList.contains("tab-button")) return;
      const targetTab = btn.getAttribute("data-tab");
      tabButtons.forEach(b => b.classList.remove("active"));
      tabPanels.forEach(p => p.classList.remove("active"));
      btn.classList.add("active");

      const activePanel = container.querySelector(`.tab-panel[data-tab="${targetTab}"]`);
      if (activePanel) activePanel.classList.add("active");
      if (tabButtonsSlider) {
        const buttonRect = btn.getBoundingClientRect();
        const containerRect = tabButtonsSlider.getBoundingClientRect();
        const offset = buttonRect.left - containerRect.left - (containerRect.width / 2) + (buttonRect.width / 2);
        tabButtonsSlider.scrollBy({ left: offset, behavior: "smooth" });
      }
    });
  }

  if (tabButtons.length > 0 && tabPanels.length > 0) {
    tabButtons[0].classList.add("active");
    tabPanels[0].classList.add("active");
  }
}
adjustaaaa();
// Size 弹窗
function initializeSizeChart() {
  const myBtn = document.querySelector('.product-size-chart');
  const switchButtons = document.querySelectorAll('.switch-button');
  const popupCloseButton = document.querySelector('#popup-size-close');
  const popup = document.querySelector('#popup-up-size');
  const sizeChartTbInch = document.querySelector('.size_chart-tb.inch');
  const sizeChartTbCm = document.querySelector('.size_chart-tb.cm');

  if (myBtn) {
    myBtn.addEventListener('click', function() {
      popup.classList.add('is-show');
    });
  }

  switchButtons.forEach(function(button) {
    button.addEventListener('click', function() {
      switchButtons.forEach(function(sibling) {
        sibling.classList.toggle('on', sibling === button);
      });
      const dataTarget = this.getAttribute('data-target');
      const isCm = dataTarget === 'cm';
      sizeChartTbInch.classList.toggle('current', !isCm);
      sizeChartTbCm.classList.toggle('current', isCm);
    });
  });

  if (popupCloseButton) {
    popupCloseButton.addEventListener('click', function() {
      popup.classList.remove('is-show');
    });
  }
}
  initializeSizeChart();

// YOUtub
function initializeVideoLink() {
  const videoLink = document.querySelector('a[data-youtube]');
  if (videoLink) {
    let id = new URL(videoLink.href).searchParams.get('v');
    videoLink.setAttribute('data-youtube', id);
    videoLink.setAttribute('role', 'button');
    videoLink.innerHTML = `
      <img srcset="https://img.youtube.com/vi/${id}/maxresdefault.jpg" loading="lazy">
      <img srcset="https://cdn.shopifycdn.net/s/files/1/0478/8607/4024/files/youtub.png?v=1660038227" loading="lazy" class="youtub-ico">
      <br>${videoLink.textContent}
    `;

    function clickHandler(event) {
      let link = event.target.closest('[data-youtube]');
      if (!link) return;
      event.preventDefault();
      let id = link.getAttribute('data-youtube');
      let player = document.createElement('div');
      player.innerHTML = `
        <div class="video-wrapper">
          <iframe 
            src="https://www.youtube-nocookie.com/embed/${id}?autoplay=1" 
            title="YouTube video player" 
            frameborder="0" 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
            allowfullscreen>
          </iframe>
        </div>`;
      link.replaceWith(player);
    }

    document.addEventListener('click', clickHandler);

    // Adjust the product video display based on screen size
    const screenWidth = window.innerWidth;
    if (screenWidth > 1000) {
      const productMedia = document.getElementsByTagName('product-media')[0];
      const productVideos = document.querySelector('.product-videos');

      if (productMedia && productVideos) {
        const hiddenClass = screenWidth <= 999 ? 'hidden-lap-and-up' : 'hidden-pocket';
        productVideos.classList.remove('hidden-lap-and-up');
        productVideos.classList.add(hiddenClass);
        productMedia.appendChild(productVideos);
      }
    }
  }
}

  initializeVideoLink();



// Size 功能
const swatches = document.querySelectorAll('.block-swatch');
swatches.forEach((swatch, index) => {
  swatch.addEventListener('click', () => {
    const inputValue = swatch.querySelector('input').value;
    const rowScroll = document.querySelector('.row-scroll');
    const shopifyPaymentButton = document.querySelector('.shopify-payment-button');
    const addToCart = document.querySelector('#AddToCart');
    const addToCartFalse = document.querySelector('#AddToCartfalse');

    if (inputValue.includes('Custom Size')) {
      rowScroll.classList.add('hiddend');
      if (document.querySelector('.single_custom-size')) {
        document.querySelector('.single_custom-size').classList.remove('hiddend');
      }
      if (shopifyPaymentButton) shopifyPaymentButton.classList.add('hiddend');
      addToCart.classList.add('hiddend');
      addToCartFalse.classList.remove('hiddend');

var inputsAndSelect = document.querySelectorAll('.check_valid');
var productForm = document.querySelector('.product-form');
var formId = productForm.getAttribute('form-ids'); 
  inputsAndSelect.forEach(function(elem) {
    elem.setAttribute('form', formId); 
  });
    } else {
      rowScroll.classList.remove('hiddend');
      if (document.querySelector('.single_custom-size')) {
        document.querySelector('.single_custom-size').classList.add('hiddend');
      }
      if (shopifyPaymentButton) shopifyPaymentButton.classList.remove('hiddend');
      addToCart.classList.remove('hiddend');
      addToCartFalse.classList.add('hiddend');

      var inputsAndSelect = document.querySelectorAll('.check_valid');
      inputsAndSelect.forEach(function(elem) {
        elem.value = '';
        elem.removeAttribute('form');
      });

      const tbody = document.querySelector('.row-scroll tbody');
      const rows = tbody.querySelectorAll('tr');
      const clickedRow = rows[index];
      rows.forEach((row) => {
        row.classList.remove('active');
        row.style.display = 'none';
      });
      clickedRow.classList.add('active');
      clickedRow.style.display = 'table-row';

      const activeIndex = Array.from(rows).indexOf(clickedRow);
      const numVisibleRows = 3;
      const totalRows = rows.length;

      const startIndex = Math.max(0, activeIndex - 1);
      const endIndex = Math.min(totalRows - 1, activeIndex + 1);

      rows.forEach((row, i) => {
        row.style.display = (i >= startIndex && i <= endIndex) ? 'table-row' : 'none';
      });

      const sizeValue = document.querySelector('#size-value-cici');
      sizeValue.textContent = swatch.querySelector('.block-swatch__item').textContent.trim();
    }
  });
});

// CM/IN 切换复选框元素
var toggleCheckbox = document.getElementById('toggle');
if (toggleCheckbox) {
toggleCheckbox.addEventListener('click', function() {
  var tdElements = document.querySelectorAll('.row-scroll table td');
  var inputElements = document.querySelectorAll('.custom-option-properties input');
  var sizeElements = document.querySelectorAll('.custom-option-properties-size');
  for (var i = 0; i < tdElements.length; i++) {
    var tdElement = tdElements[i];
    var text = tdElement.textContent;

    if (text.includes('cm')) {
      var matches = text.match(/([\d½]+(?:\.\d+)?)/);
      if (matches && matches.length > 1) {
        var centimeters = parseFraction(matches[1]);
        var inches = centimeters / 2.54;
        var newText = inches.toFixed(1) + ' in';
        tdElement.setAttribute('data-original-text', text);
        tdElement.textContent = newText;
      }
    } else if (text.includes('in')) {
      var originalText = tdElement.getAttribute('data-original-text');
      if (originalText) {
        tdElement.textContent = originalText;
        tdElement.removeAttribute('data-original-text');
      }
    }
  }
  inputElements.forEach(function(input) {
        input.value = '';
    var sizeElement = input.nextElementSibling;
    var sizeText = sizeElement.textContent;
    if (sizeText.includes('cm')) {
      var placeholder = input.getAttribute('placeholder');
      if(placeholder){
              var minMax = placeholder.split(' - ');
      var newMin = Math.round(parseFloat(minMax[0]) / 2.54);
      var newMax = Math.round(parseFloat(minMax[1]) / 2.54);
      input.setAttribute('placeholder', newMin + ' - ' + newMax);
      input.setAttribute('min', newMin);
      input.setAttribute('max', newMax);
      }

    } else if (sizeText.includes('in')) {
      var placeholder = input.getAttribute('placeholder');
            if(placeholder){
              var minMax = placeholder.split(' - ');
      var newMin = Math.round(parseFloat(minMax[0]) * 2.54);
      var newMax = Math.round(parseFloat(minMax[1]) * 2.54);

      input.setAttribute('placeholder', newMin + ' - ' + newMax);
      input.setAttribute('min', newMin);
      input.setAttribute('max', newMax);
      }

    }
  });  
  sizeElements.forEach(function(sizeElement) {
    var sizeText = sizeElement.textContent;

    if (sizeText.includes('cm')) {
      sizeElement.textContent = '(in)';
    } else if (sizeText.includes('in')) {
      sizeElement.textContent = '(cm)';
    }
  });
});
}
function parseFraction(fraction) {
  var matches = fraction.match(/(\d+)(½|\.\d+)?/);
  if (matches && matches.length > 1) {
    var wholeNumber = parseInt(matches[1]);
    var decimalPart = matches[2] ? parseFloat(matches[2]) : 0;
    return wholeNumber + decimalPart;
  } else {
    return parseFloat(fraction);
  }
}




// Custom Size 必选

var inputFields = document.querySelectorAll('.custom-option-properties input[type="number"]');
var returnSupportCheckbox = document.querySelector('#return_support_checkbox');
var shopifyPaymentButton = document.querySelector('.shopify-payment-button');
var addToCart = document.querySelector('#AddToCart');
var addToCartFalse = document.querySelector('#AddToCartfalse');

function updateButtonVisibility() {
  var isAllInputsInRange = true;

  inputFields.forEach(function(input) {
    var value = parseFloat(input.value);
    var min = parseFloat(input.getAttribute('min'));
    var max = parseFloat(input.getAttribute('max'));

    if (isNaN(value) || value < min || value > max) {
      isAllInputsInRange = false;
      input.classList.add('false-input');
    } else {
      input.classList.remove('false-input');
    }
  });

  if (isAllInputsInRange && (!returnSupportCheckbox || returnSupportCheckbox.checked)) {
    if (shopifyPaymentButton) shopifyPaymentButton.classList.remove('hiddend');
    addToCart.classList.remove('hiddend');
    addToCartFalse.classList.add('hiddend');
    document.querySelector('.error_suggestion').textContent = "";
  } else {
    if (shopifyPaymentButton) shopifyPaymentButton.classList.add('hiddend');
    addToCart.classList.add('hiddend');
    addToCartFalse.classList.remove('hiddend');
  }
}

inputFields.forEach(function(input) {
  input.addEventListener('input', function() {
    setTimeout(function() {
      updateButtonVisibility();
    }, 0);
  });
});

if (returnSupportCheckbox) {
returnSupportCheckbox.addEventListener('click', function() {
  setTimeout(function() {
    updateButtonVisibility();
  }, 0);
});
}

updateButtonVisibility();

  // 刚进页面时候的状态
document.addEventListener('DOMContentLoaded', function() {
  var selectedRadio = document.querySelector('.block-swatch__radio:checked');

  if (selectedRadio && selectedRadio.value.includes('Custom Size')) {
    if (shopifyPaymentButton) shopifyPaymentButton.classList.add('hiddend');
    addToCart.classList.add('hiddend');
    addToCartFalse.classList.remove('hiddend');


    var inputsAndSelect = document.querySelectorAll('.check_valid');
var productForm = document.querySelector('.product-form');
var formId = productForm.getAttribute('form-ids');
  inputsAndSelect.forEach(function(elem) {
    elem.setAttribute('form', formId);
  });
  } else {
    if (shopifyPaymentButton) shopifyPaymentButton.classList.remove('hiddend');
    addToCart.classList.remove('hiddend');
    addToCartFalse.classList.add('hiddend');

    var inputsAndSelect = document.querySelectorAll('.check_valid');
    inputsAndSelect.forEach(function(elem) {
      elem.removeAttribute('form');
      elem.classList.remove('false-input');
    });
  }
});

// 点击false cart状态
document.querySelector('#AddToCartfalse').addEventListener('click', function() {
  var inputFields = document.querySelectorAll('.custom-option-properties input[type="number"]');
  var returnSupportCheckbox = document.querySelector('#return_support_checkbox');
  var missingFields = [];

  inputFields.forEach(function(input) {
    var fieldName = input.getAttribute('name');
    fieldName = fieldName.replace('properties[', '').replace(']', '');
    if (input.value.trim() === '') {
      missingFields.push(fieldName);
    }
  });
  if (returnSupportCheckbox && !returnSupportCheckbox.checked) {
    missingFields.push('Please accept our terms and conditions');
  }
  var errorMessage = '';
  if (missingFields.length > 0) {
    errorMessage = 'Please provide: ' + missingFields.join(', ') + '.';
  }
  document.querySelector('.error_suggestion').textContent = errorMessage;
  if (missingFields.length === 0) {
    document.querySelector('#AddToCart').click();
  }
});




     // 获取所有的输入框和下拉菜单选中状态
  var inputFieldsa = document.querySelectorAll('.custom-option-properties input[type="number"]');
        var selectFieldsa = document.querySelectorAll('.check_valid-select');
        inputFieldsa.forEach(function(input) {
            input.addEventListener('focus', function() {
                var description = this.previousElementSibling.getAttribute('data-description');
                var descElement = document.querySelector('#single_custom-size-desc');
                descElement.innerHTML = '';
                descElement.innerHTML = description;
            });
        });
        selectFieldsa.forEach(function(select) {
            select.addEventListener('change', function() {
                var description = this.previousElementSibling.getAttribute('data-description');
                var descElement = document.querySelector('#single_custom-size-desc');
                descElement.innerHTML = '';
                descElement.innerHTML = description;
            });
        });






